import CommonState from './CommonState'
import Model from '@/class/cargo/model/utils/Model'

export function getCommonState(code, list) {
  for (var common of list) {
    if (common.code === code) {
      return common
    }
  }
  return null
}

export const ALL = new CommonState(null, '-所有-', '-All-')

export const RECEIVE_TYPE_CASH = new CommonState(0, '现金', 'Cash')
export const RECEIVE_TYPE_CHECK = new CommonState(1, '支票', 'Check')
export const RECEIVE_TYPE_TRANSFER = new CommonState(2, '银行转账', 'Transfer')
export const RECEIVE_TYPE_SELF = new CommonState(3, '本票', 'Self')
export const RECEIVE_TYPE_AGENT = new CommonState(4, '代收代付', 'Agent')
export const RECEIVE_TYPE_CASHTRANSFER = new CommonState(5, '水单', 'CashTransfer')
export const RECEIVE_TYPE_COUNTERBALANCE = new CommonState(6, '冲账', 'Counterbalance')
export const RECEIVE_TYPE_THIRD_PLATFORM = new CommonState(7, '第三方支付平台', 'ThirdPlatform')
export const BANK_ACCEPTANCE_BILL = new CommonState(50, '银行承兑汇票', 'BankAcceptanceBill')
export const COMMERCIAL_ACCEPTANCE_BILL = new CommonState(51, '商业承兑汇票', 'CommercialAcceptanceBill')
export const RECEIVE_TYPE_REFUND = new CommonState(52, '水单退款', 'WaterbillRefund')
export const RECEIVE_TYPE_OTHER = new CommonState(53, '其他', 'Other')
export const RECEIVE_TYPE_VIRTUAL_CASH = new CommonState(54, '虚拟现金', 'VirtualCash')
/**
 * 收付方式
 */
export const AMOUNT_RECEIVE_TYPES = new Set([
  RECEIVE_TYPE_CASH,
  RECEIVE_TYPE_CHECK,
  RECEIVE_TYPE_TRANSFER,
  RECEIVE_TYPE_SELF,
  RECEIVE_TYPE_AGENT,
  RECEIVE_TYPE_CASHTRANSFER,
  RECEIVE_TYPE_COUNTERBALANCE,
  RECEIVE_TYPE_THIRD_PLATFORM,
  BANK_ACCEPTANCE_BILL,
  COMMERCIAL_ACCEPTANCE_BILL,
  RECEIVE_TYPE_REFUND,
  RECEIVE_TYPE_OTHER,
  RECEIVE_TYPE_VIRTUAL_CASH
])

export const ACTUAL_RECEIVE = new CommonState(true, '实收', 'Receive')
export const ACTUAL_PAYMENT = new CommonState(false, '实付', 'Payment')

export const ACTUAL_TYPES = new Set([
  ACTUAL_RECEIVE,
  ACTUAL_PAYMENT
])

export const ACTUAL_TYPES_OPTIONS = new Set([
  ALL,
  ACTUAL_RECEIVE,
  ACTUAL_PAYMENT
])

export const ACCOUNT_TYPE_NORMAL = new CommonState(0, '一般客户', 'Normal')
export const ACCOUNT_TYPE_MONTHLY = new CommonState(1, '月结客户', 'Monthly')

export const ACCOUNT_TYPES_OPTIONS = new Set([
  ALL,
  ACCOUNT_TYPE_NORMAL,
  ACCOUNT_TYPE_MONTHLY
])

/**
 * 付款申请状态
 */
export const BILL_PAYMENT_NOT_COMMIT = new CommonState(0, '未提交', 'Not Commit')
export const BILL_PAYMENT_COMMITED = new CommonState(1, '已提交', 'Committed')
export const BILL_PAYMENT_BIZ_APPROVED = new CommonState(2, '已业务审批', 'Business Approved')
export const BILL_PAYMENT_FINANCE_APPROVED = new CommonState(3, '已财务审批', 'Finance Approved')
export const BILL_PAYMENT_PAID = new CommonState(4, '已付款', 'Paid')
export const BILL_PAYMENT_BLOCKED = new CommonState(5, '已冻结', 'Blocked')
export const BILL_PAYMENT_DEP_APROVED = new CommonState(6, '已部门审批', 'Department Approved')

export const BILL_PAYMENT_WEAVER_APPROVING = new CommonState(7, '云平台审批中', 'Weaver Approving')
export const BILL_PAYMENT_WEAVER_APPROVED = new CommonState(8, '云平台审批通过', 'Weaver Approved')

export const BILL_PAYMENT_APPROVING_BPM = new CommonState(9, '审批中', 'Commited')
export const BILL_PAYMENT_APPROVED_BPM = new CommonState(10, '审批通过', 'Approved')
export const BILL_PAYMENT_SUPERVISOR_APPROVED = new CommonState(11, '主管审批', 'Supervisor Approved')
// export const BILL_PAYMENT_VOIDED_BPM = new CommonState(11, '作废', 'VOIDED')

export const BILL_PAYMENT_STATES = new Set([
  BILL_PAYMENT_NOT_COMMIT,
  BILL_PAYMENT_COMMITED,
  BILL_PAYMENT_BIZ_APPROVED,
  BILL_PAYMENT_FINANCE_APPROVED,
  BILL_PAYMENT_PAID,
  BILL_PAYMENT_BLOCKED,
  BILL_PAYMENT_DEP_APROVED,
  BILL_PAYMENT_WEAVER_APPROVING,
  BILL_PAYMENT_WEAVER_APPROVED,
  BILL_PAYMENT_APPROVING_BPM,
  BILL_PAYMENT_APPROVED_BPM,
  BILL_PAYMENT_SUPERVISOR_APPROVED
  // ,
  // BILL_PAYMENT_VOIDED_BPM
])

export const BILL_PAYMENT_STATES_OPTIONS = new Set([
  ALL,
  BILL_PAYMENT_NOT_COMMIT,
  BILL_PAYMENT_COMMITED,
  BILL_PAYMENT_BIZ_APPROVED,
  BILL_PAYMENT_FINANCE_APPROVED,
  BILL_PAYMENT_PAID,
  BILL_PAYMENT_BLOCKED,
  BILL_PAYMENT_DEP_APROVED
])

/**
 * 付款申请【业务】【财务】【财务部】审批状态
 */
export const BILL_PAYMENT_APPROVE_NO_PASS = new CommonState(2, '拒绝', 'No Pass')
export const BILL_PAYMENT_APPROVE_PASS = new CommonState(1, '同意', 'Pass')
export const BILL_PAYMENT_APPROVE_WAIT = new CommonState(0, '待审批', 'Pending approval')

export const BILL_PAYMENT_APPROVE_STATE = new Set([
  BILL_PAYMENT_APPROVE_NO_PASS,
  BILL_PAYMENT_APPROVE_PASS,
  BILL_PAYMENT_APPROVE_WAIT
])

/**
 * 付款申请历史-审批结果
 */
export const BILL_PAYMENT_APPROVE_RESULTS_NO_PASS = new CommonState(0, '拒绝', 'Refuse')
export const BILL_PAYMENT_APPROVE_RESULTS_PASS = new CommonState(1, '同意', 'Agree')

export const BILL_PAYMENT_APPROVAL_RESULTS = new Set([
  BILL_PAYMENT_APPROVE_RESULTS_NO_PASS,
  BILL_PAYMENT_APPROVE_RESULTS_PASS
])

/**
 * 付款申请审批节点
 * @type {Set<CommonState>}
 */
export const BILL_PAYMENT_APPROVE_NODE_BIZ_APPROVE = new CommonState('业务审批', '业务审批', 'Business Approve')
export const BILL_PAYMENT_APPROVE_NODE_FINANCE_APPROVE = new CommonState('财务审批', '财务审批', 'Finance Approve')
export const BILL_PAYMENT_APPROVE_NODE_APPROVED = new CommonState('审批通过', '审批通过', 'Approved')
export const BILL_PAYMENT_APPROVE_NODE_NOT_COMMIT = new CommonState('待提交', '待提交', 'Not Commit')
export const BILL_PAYMENT_APPROVE_NODE_DEP_APPROVE = new CommonState('部门审批', '部门审批', 'Department Approve')
export const BILL_PAYMENT_APPROVE_NODE_FINANCE_REVIEW = new CommonState('财务审核', '财务审核', 'Finance review')
export const BILL_PAYMENT_APPROVE_NODE_COMMERCE_APPROVE = new CommonState('商务审批', '商务审批', 'Commerce Approve')

export const BILL_PAYMENT_APPROVE_NODE = new Set([
  BILL_PAYMENT_APPROVE_NODE_BIZ_APPROVE,
  BILL_PAYMENT_APPROVE_NODE_FINANCE_APPROVE,
  BILL_PAYMENT_APPROVE_NODE_APPROVED,
  BILL_PAYMENT_APPROVE_NODE_NOT_COMMIT,
  BILL_PAYMENT_APPROVE_NODE_DEP_APPROVE,
  BILL_PAYMENT_APPROVE_NODE_FINANCE_REVIEW,
  BILL_PAYMENT_APPROVE_NODE_COMMERCE_APPROVE
])

/**
 * 付款申请查询条件
 */
export const DEFAULT_OPTION = new CommonState(null, '-请选择-', 'Please Select')
// 带业务审批
export const BILL_PAYMENT_UN_VERIFY = new CommonState(1, '待业务审批', 'Department Approved', new Set([
  BILL_PAYMENT_COMMITED,
  BILL_PAYMENT_DEP_APROVED
])
)
// 待财务审批
export const BILL_PAYMENT_FINANCE_UN_VERIFY = new CommonState(2, '待财务审批', 'Pending financial approval')
// 审批通过
export const BILL_PAYMENT_FINANCE_VERIFIED = new CommonState(3, '审批通过', 'Verified')
// 未付清
export const BILL_PAYMENT_NOT_PAID = new CommonState(4, '未付清', 'Department Approved', new Set([
  BILL_PAYMENT_NOT_COMMIT,
  BILL_PAYMENT_COMMITED
])
)

export const BILL_PAYMENT_QUERY_STATES = new Set([
  BILL_PAYMENT_NOT_COMMIT,
  BILL_PAYMENT_UN_VERIFY,
  BILL_PAYMENT_FINANCE_UN_VERIFY,
  BILL_PAYMENT_FINANCE_VERIFIED,
  BILL_PAYMENT_NOT_PAID
])

// 未付清
export const BILL_PAYMENT_PAYNOT_PAID = new CommonState('-1', '未付清', 'Department Approved', new Set([
])
)

export const BILL_PAYMENT_APPLYQUERY_STATES = new Set([
  ALL,
  BILL_PAYMENT_NOT_COMMIT,
  BILL_PAYMENT_UN_VERIFY,
  BILL_PAYMENT_FINANCE_UN_VERIFY,
  BILL_PAYMENT_FINANCE_VERIFIED,
  BILL_PAYMENT_PAYNOT_PAID,
  BILL_PAYMENT_APPROVING_BPM,
  BILL_PAYMENT_APPROVED_BPM
  // ,
  // BILL_PAYMENT_VOIDED_BPM
])

export const CLEARING_STATE_NON = new CommonState(0, '未核销', 'Non-Write')
export const CLEARING_STATE_PARTIAL = new CommonState(1, '部分核销', 'Partial Writeoff')
export const CLEARING_STATE_FULL = new CommonState(2, '全部核销', 'Full Writeoff')
export const CLEARING_STATE_TOBE_CONFIRMED = new CommonState(3, '总部核销待确认', 'ToBe Confiromed')

export const CLEARING_STATE_FULL_WARNING = new CommonState(4, '全部核销!', 'Full Writeoff')
export const CLEARING_STATE_TOBE_CONFIRMED_WARNING = new CommonState(5, '总部核销待确认!', 'ToBe Confiromed')

// 实收实付模块:核销状态查询条件
export const ACTUALAMOUNT_CLEARING_STATES = new Set([
  CLEARING_STATE_NON,
  CLEARING_STATE_PARTIAL,
  CLEARING_STATE_FULL
])

export const CLEARING_STATES = new Set([
  CLEARING_STATE_NON,
  CLEARING_STATE_PARTIAL,
  CLEARING_STATE_FULL,
  CLEARING_STATE_TOBE_CONFIRMED
])

export const CLEARING_STATES_ALL = new Set([
  CLEARING_STATE_NON,
  CLEARING_STATE_PARTIAL,
  CLEARING_STATE_FULL,
  CLEARING_STATE_TOBE_CONFIRMED,
  CLEARING_STATE_FULL_WARNING,
  CLEARING_STATE_TOBE_CONFIRMED_WARNING
])

export const CLEARING_STATE_NON_BILL = new CommonState('0', '未核销', 'Non-Write')
export const CLEARING_STATE_PARTIAL_BILL = new CommonState('1', '部分核销', 'Partial Writeoff')
export const CLEARING_STATE_FULL_BILL = new CommonState('2', '全部核销', 'Full Writeoff')

export const CLEARING_STATES_ALL_BILL = new Set([
  CLEARING_STATE_NON_BILL,
  CLEARING_STATE_PARTIAL_BILL,
  CLEARING_STATE_FULL_BILL
])

export const ACT_AMOUNT_APPROVE_NONE = new CommonState(0, '未复核', 'Non Approve')
export const ACT_AMOUNT_APPROVED = new CommonState(1, '已复核', 'Approved')

export const ACT_AMOUNT_APPROVE_STATES = new Set([
  ACT_AMOUNT_APPROVE_NONE,
  ACT_AMOUNT_APPROVED
])

// 核销匹配状态（导入数据专用）
export const MATCH_STATUS_UNMATCHED = new CommonState(0, '未匹配', 'Unmatched')
export const MATCH_STATUS_AUTO_WRITTEN_OFF = new CommonState(1, '匹配已自动核销', 'Auto Written Off')
export const MATCH_STATUS_MANUAL = new CommonState(2, '手动核销', 'Manual Write-off')
export const MATCH_STATUS_NO_NEED = new CommonState(3, '无需核销', 'No Need Write-off')

export const WRITEOFF_MATCH_STATUSES = new Set([
  MATCH_STATUS_UNMATCHED,
  MATCH_STATUS_AUTO_WRITTEN_OFF,
  MATCH_STATUS_MANUAL,
  MATCH_STATUS_NO_NEED
])

export const CLEAR_HISTORY_STATE_UNCONFIRMED = new CommonState(1, '未确认', 'Unconfirmed')
export const CLEAR_HISTORY_STATE_CONFIRMED = new CommonState(2, '已确认', 'Confirmed')

export const CLEAR_HISTORY_STATES_ALL = new Set([
  new CommonState(null, '全部', 'ALL'),
  CLEAR_HISTORY_STATE_UNCONFIRMED,
  CLEAR_HISTORY_STATE_CONFIRMED
])

export const BANK_SLIP_UNRELEASE_STATES = new CommonState(0, '未发布', 'UnRelease')
export const BANK_SLIP_RELEASE_STATES = new CommonState(1, '已发布', 'Release')

export const BANK_SLIP_RELEASE_STATES_ALL = new Set([
  new CommonState(null, '全部', 'ALL'),
  BANK_SLIP_UNRELEASE_STATES,
  BANK_SLIP_RELEASE_STATES
])

export const BANK_SLIP_UNSTATES = new CommonState(0, '未认领', 'UnBankSlipState')
export const BANK_SLIP_PART_STATES = new CommonState(1, '部分认领', 'PartBankSlipState')
export const BANK_SLIP_STATES = new CommonState(2, '已认领', 'BankSlipState')
export const BANK_SLIP_RETURN_STATES = new CommonState(3, '已退回', 'BankSlipReturnState')
export const BANK_SLIP_VOUCHER_STATES = new CommonState(4, '已生成预收凭证', 'BankSlipVoucherState')
export const BANK_SLIP_RETURN_VOUCHER_STATES = new CommonState(5, '已生成退回凭证', 'BankSlipReturnVoucherState')

export const BANK_SLIP_STATES_ALL = new Set([
  BANK_SLIP_UNSTATES,
  BANK_SLIP_PART_STATES,
  BANK_SLIP_STATES,
  BANK_SLIP_RETURN_STATES,
  BANK_SLIP_VOUCHER_STATES,
  BANK_SLIP_RETURN_VOUCHER_STATES
])

/**
 * 付款申请思锐申请 审批节点
 */
export const APPROVAL_NODE_NOT_COMMIT = new CommonState(0, '未提交', 'Not Commit')
export const APPROVAL_NODE_UNDER = new CommonState(1, '审批中', 'Under Approval')
export const APPROVAL_NODE_COMPLETE = new CommonState(3, '审批完成', 'Approved Completed')

export const APPROVAL_NODES = new Set([
  APPROVAL_NODE_NOT_COMMIT,
  APPROVAL_NODE_UNDER,
  APPROVAL_NODE_COMPLETE
])

/**
 * 水单状态
 */
export const CASH_TRANSFER_WSY = new CommonState(0, '未使用', 'WSY')
export const CASH_TRANSFER_GSD = new CommonState(1, '挂水单', 'GSD')
export const CASH_TRANSFER_SDK = new CommonState(2, '收到款', 'SDK')
export const CASH_TRANSFER_NDHD = new CommonState(3, '拿到回单', 'NDHD')

export const CASH_TRANSFER_STATES = new Set([
  CASH_TRANSFER_WSY,
  CASH_TRANSFER_GSD,
  CASH_TRANSFER_SDK,
  CASH_TRANSFER_NDHD
])

export const CONTRACT_STATUS_NO = new CommonState(0, '无合同', 'No contract')
export const CONTRACT_STATUS_INVALID = new CommonState(1, '已无效', 'Invalid')
export const CONTRACT_STATUS_NORMAL = new CommonState(2, '正常', 'Normal')

export const SETTLEMENT_CONTRACT_STATUS = new Set([
  CONTRACT_STATUS_NO,
  CONTRACT_STATUS_INVALID,
  CONTRACT_STATUS_NORMAL
])

export const BILLING_IS_AR_LIST = ['ALL', 'Credit', 'Debit']
export const CURRENCY_LIST_OPTION = ['ALL', 'USD', 'RMB', 'HKD', 'EUR']
export const AMOUNT_RECEIVE_TYPE_LIST_OPTION = ['ALL', '现金', '支票', '转账', '本票', '代收代付']

export const BILL_CLEARING_STATES = new Set([
  ALL,
  CLEARING_STATE_NON_BILL,
  CLEARING_STATE_PARTIAL_BILL,
  CLEARING_STATE_FULL_BILL,
  CLEARING_STATE_TOBE_CONFIRMED])

export const BILLING_CLEARING_STATES = new Set([
  ALL,
  CLEARING_STATE_NON,
  CLEARING_STATE_PARTIAL,
  CLEARING_STATE_FULL,
  CLEARING_STATE_TOBE_CONFIRMED])

export const NOT_SENT = new CommonState(0, '未发送', 'Not Sent')
export const SENT = new CommonState(1, '已发送', 'Sent')
export const BRANCH_CONFIRMED = new CommonState(2, '分公司已确认', 'Branch Confirmed')
export const CONFIRM_STATE = new Set([
  NOT_SENT,
  SENT,
  BRANCH_CONFIRMED
])
/**
 *  return null:没找到.
 */
export function getClearingBankSlipByCode(code, arr) {
  return Model.getObjByCode(code, arr)
}

export const BILL_PAYMENT_PRE_STATE_BUSINESS_APPROVAL = new CommonState(1, '业务审核', 'business approval')
export const BILL_PAYMENT_PRE_STATE_DEPARTMENT_APPROVAL = new CommonState(2, '部门审核', 'department approval')
export const BILL_PAYMENT_PRE_STATE_FINANCE_APPROVAL = new CommonState(3, '财务审核', 'finance approval')
export const BILL_PAYMENT_PRE_STATES = new Set([
  BILL_PAYMENT_PRE_STATE_BUSINESS_APPROVAL,
  BILL_PAYMENT_PRE_STATE_DEPARTMENT_APPROVAL,
  BILL_PAYMENT_PRE_STATE_FINANCE_APPROVAL
])

/**
 * CARGO-46068 退款状态
 */
export const BANK_SLIP_RETURN_APPLY_STATE_NOREFUND = new CommonState(0, '未退款', 'No refund')
export const BANK_SLIP_RETURN_APPLY_STATE_PENDING = new CommonState(1, '审批中', 'Pending Approval')
export const BANK_SLIP_RETURN_APPLY_STATE_REFUNDED = new CommonState(2, '已退款', 'Refunded ')
export const BANK_SLIP_RETURN_APPLY_STATE_REJECTED = new CommonState(3, '已拒绝', 'Rejected')
export const BANK_SLIP_RETURN_APPLY_STATE_CANCELED = new CommonState(4, '已撤回', 'Canceled')

export const BANK_SLIP_RETURN_APPLY_STATES = new Set([
  BANK_SLIP_RETURN_APPLY_STATE_NOREFUND,
  BANK_SLIP_RETURN_APPLY_STATE_PENDING,
  BANK_SLIP_RETURN_APPLY_STATE_REFUNDED,
  BANK_SLIP_RETURN_APPLY_STATE_REJECTED,
  BANK_SLIP_RETURN_APPLY_STATE_CANCELED
])

export const VERIFY_STATE_NONE_RECEIVABLE = new CommonState(0, '无应收', 'None Receivable')
export const VERIFY_STATE_NON = new CommonState(1, '未核销', 'Non Writeoff')
export const VERIFY_STATE_PARTIAL = new CommonState(2, '部分核销', 'Partial Writeoff')
export const VERIFY_STATE_FULL = new CommonState(3, '全部核销', 'Full Writeoff')

// 应收核销状态
export const RECEIVABLE_VERIFY_STATES = new Set([
  VERIFY_STATE_NONE_RECEIVABLE,
  VERIFY_STATE_NON,
  VERIFY_STATE_PARTIAL,
  VERIFY_STATE_FULL
])
